import React from "react";
import './coursesoffstyle.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import gamerules from '../../imagesHome/game-rules.png';
import SocialLoginRegistrer from './SocialLoginRegistrer';
import Registrercourse from './Registrercourse';

const PageGameFinancialRulesOff = () => {
  return (
    <div className="general-frame-bc-cf">
    <div className="general-frame-game">
      {/* 🔹 Breadcrumb */}
     

      <div className="game-hero-section">
        {/* 🔹 Stânga - Titlu și descriere */}

        <div className="breadcrumb-game">
          <span>Jocuri</span>
          <FontAwesomeIcon icon={faChevronRight} className="breadcrumb-game-icon" />
          <span className="current">Regulile de functionare ale conturilor</span>
        </div>
        <div className="game-hero-content">

       <div className="game-hero-left">
  <img src={gamerules} alt="reguli functionare conturi" />
  <h1>Cum functioneaza conturile?</h1>
  <p>
    Invata prin joc cum functioneaza conturile contabile in practica!
    Acest mini-joc interactiv iti arata exemple concrete de cum se folosesc
    conturile in operatiuni reale de afaceri.
  </p>
  <p>
    Vei descoperi cum se inregistreaza achizitii, vanzari, plati salarii,
    incasari de la clienti si multe altele. Fiecare exemplu iti arata
    care conturi se folosesc si cum se face inregistrarea corecta.
  </p>
  <p>
    Perfect pentru a fixa cunostintele practice si a vedea cum functioneaza
    contabilitatea in viata reala!
  </p>
</div>


        {/* 🔹 Dreapta - card/formular */}
        <div className="game-hero-right">
          <div className="game-card">
            <h2>Inregistreaza-te gratuit pe ContaLearn</h2>
            <p>Acceseaza jocul si exerseaza inregistrarile contabile!</p>
          

               <div><Registrercourse /></div>
               <div className="sau-game">sau</div>
               <div><SocialLoginRegistrer /></div>
          </div>
        </div>
        </div>
      </div>

    

    </div>
      
      {/* 🔹 Secțiunea 2: Ce vei învăța */}
      <div className="game-learn-section">
        <div className="game-learn-container">
          <h2 className="game-section-title">Ce vei exersa in acest joc</h2>
          <p className="game-section-subtitle">
            Exemple practice din viata reala care iti arata cum se folosesc conturile in operatiuni curente de afaceri.
          </p>

          <div className="game-cards-grid">
            {/* Exemplu 1 */}
            <div className="game-feature-card">
              <span className="game-card-icon">🛒</span>
              <h3 className="game-card-title">Achizitii de bunuri si servicii</h3>
              <p className="game-card-desc">
                Invata cum se inregistreaza achizitiile de marfa, materiale, servicii si cum functioneaza TVA-ul.
              </p>
            </div>

            {/* Exemplu 2 */}
            <div className="game-feature-card">
              <span className="game-card-icon">💰</span>
              <h3 className="game-card-title">Vanzari si incasari</h3>
              <p className="game-card-desc">
                Descopera cum se inregistreaza vanzarile, emiterea facturilor si incasarile de la clienti.
              </p>
            </div>

            {/* Exemplu 3 */}
            <div className="game-feature-card">
              <span className="game-card-icon">👥</span>
              <h3 className="game-card-title">Salarii si contributii</h3>
              <p className="game-card-desc">
                Vezi cum se calculeaza si inregistreaza salariile, contributiile sociale si platile catre angajati.
              </p>
            </div>

            {/* Exemplu 4 */}
            <div className="game-feature-card">
              <span className="game-card-icon">🏦</span>
              <h3 className="game-card-title">Operatiuni bancare</h3>
              <p className="game-card-desc">
                Exerseaza inregistrarile de incasari si plati prin banca, transferuri si viramente.
              </p>
            </div>

            {/* Exemplu 5 */}
            <div className="game-feature-card">
              <span className="game-card-icon">💳</span>
              <h3 className="game-card-title">Casa si operatiuni numerar</h3>
              <p className="game-card-desc">
                Invata sa gestionezi operatiunile in numerar: incasari, plati si deplasari casa-banca.
              </p>
            </div>

            {/* Exemplu 6 */}
            <div className="game-feature-card">
              <span className="game-card-icon">📦</span>
              <h3 className="game-card-title">Stocuri si marfa</h3>
              <p className="game-card-desc">
                Descopera cum se inregistreaza intrarile si iesirile de marfa, costurile si vanzarile.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* 🔹 Secțiunea 3: Cum funcționează jocul */}
      <div className="game-how-section">
        <div className="game-how-container">
          <h2 className="game-section-title">Cum functioneaza jocul</h2>
          
          <div className="game-steps-grid">
            <div className="game-step-item">
              <div className="game-step-icon">📖</div>
              <div className="game-step-number">1</div>
              <div className="game-step-label">Citesti situatia</div>
            </div>

            <div className="game-step-item">
              <div className="game-step-icon">🤔</div>
              <div className="game-step-number">2</div>
              <div className="game-step-label">Analizezi operatiunea</div>
            </div>

            <div className="game-step-item">
              <div className="game-step-icon">✍️</div>
              <div className="game-step-number">3</div>
              <div className="game-step-label">Vezi inregistrarea</div>
            </div>

            <div className="game-step-item">
              <div className="game-step-icon">✅</div>
              <div className="game-step-number">4</div>
              <div className="game-step-label">Inveti prin repetitie</div>
            </div>
          </div>
        </div>
      </div>

      {/* 🔹 Secțiunea 4: Beneficii */}
      <div className="game-benefits-section">
        <div className="game-benefits-container">
          <h2 className="game-section-title">De ce sa joci acest joc</h2>
          
          <div className="game-benefits-list">
            <div className="game-benefit-item">
              <div className="game-benefit-check">✓</div>
              <div>
                <h4>Exemple din viata reala</h4>
                <p>Toate situatiile sunt preluate din operatiuni curente de afaceri</p>
              </div>
            </div>

            <div className="game-benefit-item">
              <div className="game-benefit-check">✓</div>
              <div>
                <h4>Inveti prin repetitie</h4>
                <p>Cu cat joci mai mult, cu atat fixezi mai bine cunostintele</p>
              </div>
            </div>

            <div className="game-benefit-item">
              <div className="game-benefit-check">✓</div>
              <div>
                <h4>Feedback instant</h4>
                <p>Vezi imediat cum ar trebui sa fie inregistrarea corecta</p>
              </div>
            </div>

            <div className="game-benefit-item">
              <div className="game-benefit-check">✓</div>
              <div>
                <h4>Diversitate de operatiuni</h4>
                <p>Acopera toate tipurile de inregistrari contabile uzuale</p>
              </div>
            </div>

            <div className="game-benefit-item">
              <div className="game-benefit-check">✓</div>
              <div>
                <h4>Perfect pentru examen</h4>
                <p>Ideal pentru recapitulare inainte de examene sau evaluari</p>
              </div>
            </div>

            <div className="game-benefit-item">
              <div className="game-benefit-check">✓</div>
              <div>
                <h4>Aplicare practica</h4>
                <p>Treci de la teorie la practica intr-un mod distractiv</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 🔹 Secțiunea 5: Final CTA */}
      <div className="game-final-cta">
        <div className="game-cta-content">
          <h2>Gata sa te joci?</h2>
          <p>Inregistreaza-te gratuit si incepe sa exersezi contabilitatea in mod interactiv!</p>
          <div className="game-cta-buttons">
            <Registrercourse />
            <div className="sau-game-cta">sau</div>
            <SocialLoginRegistrer />
          </div>
        </div>
      </div>

    </div>
  );
};

export default PageGameFinancialRulesOff;
